// extracted by mini-css-extract-plugin
module.exports = {"input":"jXVkhE4lECdmdD44Y7ca0"};